export default {
  /**
   * Chuyển tiền trực tuyến
   */
  TransferOnline: 1,
  /**
   * Thu hồi lệnh chuyển tiền
   */
  Recall: 2,
  /**
   * Kiểm duyệt lệnh chuyển tiền
   */
  Approve: 4,
};
